module.exports = __webpack_public_path__ + "d6eba5a3b837774e319caaa462bf9d4c.pdf";